import Vue from 'vue'
import Router from 'vue-router'
import ConductorApiConfig from '@/components/ConductorApiConfig.vue'
import ConductorApiEdit from '@/components/ConductorApiEdit.vue'
import ConductorApiView from '@/components/ConductorApiView.vue'
import Workflow from '@/components/Workflow.vue'
import WorkflowCreate from '@/components/WorkflowCreate.vue'
import WorkflowRerun from '@/components/WorkflowRerun.vue'
import WorkflowSkipTask from '@/components/WorkflowSkipTask.vue'
import WorkflowList from '@/components/WorkflowList.vue'
import Task from '@/components/Task.vue'
import TaskList from '@/components/TaskList.vue'
import TaskQueueList from '@/components/TaskQueueList.vue'
import TaskResultEdit from '@/components/TaskResultEdit.vue'
import WorkflowDefinition from '@/components/WorkflowDefinition.vue'
import WorkflowDefinitionCreate from '@/components/WorkflowDefinitionCreate.vue'
import WorkflowDefinitionEdit from '@/components/WorkflowDefinitionEdit.vue'
import WorkflowDefinitionList from '@/components/WorkflowDefinitionList.vue'
import TaskDefinition from '@/components/TaskDefinition.vue'
import TaskDefinitionCreate from '@/components/TaskDefinitionCreate.vue'
import TaskDefinitionEdit from '@/components/TaskDefinitionEdit.vue'
import TaskDefinitionList from '@/components/TaskDefinitionList.vue'
import EventHandler from '@/components/EventHandler.vue'
import EventHandlerCreate from '@/components/EventHandlerCreate.vue'
import EventHandlerEdit from '@/components/EventHandlerEdit.vue'
import EventHandlerList from '@/components/EventHandlerList.vue'

import store from '@/store'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'conductorApiEdit',
      component: ConductorApiEdit
    },
    {
      path: '/api/:conductorApiId',
      name: 'conductorApiView',
      component: ConductorApiView,
      beforeEnter: (to, from, next) => {
        store.commit('loadConductorApis')
        store.commit('setConductorApiId', to.params.conductorApiId)
        next()
      },
      children: [
        {
          path: 'workflows',
          name: 'workflowList',
          component: WorkflowList
        },
        {
          path: 'workflows/create',
          name: 'workflowCreate',
          component: WorkflowCreate
        },
        {
          path: 'workflows/:workflowId',
          name: 'workflow',
          component: Workflow,
          props: true
        },
        {
          path: 'workflows/:workflowId/rerun',
          name: 'workflowRerun',
          component: WorkflowRerun,
          props: true
        },
        {
          path: 'workflows/:workflowId/skiptask',
          name: 'workflowSkipTask',
          component: WorkflowSkipTask,
          props: true
        },
        {
          path: 'queues',
          name: 'taskQueueList',
          component: TaskQueueList
        },
        {
          path: 'tasks',
          name: 'taskList',
          component: TaskList
        },
        {
          path: 'tasks/:taskId',
          name: 'task',
          component: Task,
          props: true
        },
        {
          path: 'tasks/:taskId/edit',
          name: 'taskResultEdit',
          component: TaskResultEdit,
          props: true
        },
        {
          path:
            'metadata/workflows/:workflowDefinitionName/:workflowDefinitionVersion',
          name: 'workflowDefinition',
          component: WorkflowDefinition,
          props: true
        },
        {
          path: 'metadata/workflows-creator',
          name: 'workflowDefinitionCreate',
          component: WorkflowDefinitionCreate
        },
        {
          path:
            'metadata/workflows/:workflowDefinitionName/:workflowDefinitionVersion/edit',
          name: 'workflowDefinitionEdit',
          component: WorkflowDefinitionEdit,
          props: true
        },
        {
          path: 'metadata/workflows',
          name: 'workflowDefinitionList',
          component: WorkflowDefinitionList
        },
        {
          path: 'metadata/tasks/:taskType',
          name: 'taskDefinition',
          component: TaskDefinition,
          props: true
        },
        {
          path: 'metadata/tasks-creator',
          name: 'taskDefinitionCreate',
          component: TaskDefinitionCreate
        },
        {
          path: 'metadata/tasks/:taskType/edit',
          name: 'taskDefinitionEdit',
          component: TaskDefinitionEdit,
          props: true
        },
        {
          path: 'metadata/tasks',
          name: 'taskDefinitionList',
          component: TaskDefinitionList
        },
        {
          path: 'events/:eventHandlerName',
          name: 'eventHandler',
          component: EventHandler,
          props: true
        },
        {
          path: 'events-creator',
          name: 'eventHandlerCreate',
          component: EventHandlerCreate
        },
        {
          path: 'events/:eventHandlerName/edit',
          name: 'eventHandlerEdit',
          component: EventHandlerEdit,
          props: true
        },
        {
          path: 'events',
          name: 'eventHandlerList',
          component: EventHandlerList
        },
        {
          path: 'config',
          name: 'conductorApiConfig',
          component: ConductorApiConfig
        }
      ]
    }
  ]
})
